export default __webpack_public_path__ + "static/media/rod-long-eWc6BKWduMQ-unsplash.80a11c05.png";